import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: {
      title: 'Product',
      links: [
        { name: 'Features', href: '/features' },
        { name: 'How It Works', href: '/how-it-works' },
      ]
    },
    solutions: {
      title: 'Solutions',
      links: [
        { name: 'For Schools', href: '/for-schools' },
        { name: 'For Educators', href: '/for-educators' },
        { name: 'For Parents', href: '/for-parents' },
        { name: 'For Students', href: '/for-students' },
      ]
    },
    company: {
      title: 'Company',
      links: [
        { name: 'About', href: '/about' },
        { name: 'Contact', href: '/contact' },
        { name: 'Blog', href: '/blog' },
        { name: 'Giving Back', href: '/giving-back' },
      ]
    },
    legal: {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', href: '/privacy' },
        { name: 'Terms of Service', href: '/terms' },
        { name: 'Security', href: '/security' },
      ]
    },
  };

  return (
    <footer className="bg-[var(--color-rich-black)] border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-bold leading-6 text-white mb-4">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm leading-6 text-[var(--color-medium-gray)] hover:text-[var(--color-electric-blue)] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-[var(--color-hare)]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="relative">
                <span
                  className="absolute inset-0 text-2xl font-black text-[#06b6d4] blur-md opacity-70 select-none"
                  aria-hidden="true"
                >
                  Lumen8
                </span>
                <span className="relative text-2xl font-black text-gradient">
                  Lumen8
                </span>
              </span>
              <span className="text-sm text-[var(--color-wolf)]">
                AI-Powered Adaptive Learning
              </span>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-[var(--color-wolf)]">
              <span>© {currentYear} Lumen8 Pty Ltd</span>
              <span className="hidden md:block">•</span>
              <span>All rights reserved</span>
              <span className="hidden md:block">•</span>
              <a
                href="https://lumen8.it"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[var(--color-macaw)] hover:text-[var(--color-peacock)] transition-colors"
              >
                lumen8.it
              </a>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-[var(--color-wolf)] leading-5">
              Transforming education with real-time mastery tracking aligned to the NSW curriculum.
              <br />
              Replacing quarterly report cards with continuous insight for students, teachers, and parents.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;